module.exports = __webpack_public_path__ + "img/public/SiteIcons/transportation.svg?7cbef935";